/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 01/01/2019
 */

import EmptyRouterView from "@/core/components/EmptyRouterView.vue";
import mergeProps from "@/router/utils/mergeProps";
import redirectByName from "@/router/utils/redirectByName.js";

let BillingMain = () => import(/* webpackChunkName: "BillingCenter" */ '@/core/modules/coach/Billing/BillingMain')


export default [
	{

		path: 'billing',
		name: 'billingRoot',
		redirect: redirectByName('BillingMain', {activeTab: 'invoices'}),
		component: EmptyRouterView,
		props: mergeProps,
		children: [
			{
				path: ':activeTab',
				component: BillingMain,
				name: 'BillingMain',
				props: mergeProps,
			},

		]
	},

]
